import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/orders'
import Component from 'components/Orders'

export default createListViewContainer({ actions, selectors: selectors.orders })(Component)
